<script>
import axios from "axios";

var SpatialNavigation = window.SpatialNavigation;

export default {
  name: "Video-Row",
  props: ['show'],
  data: () => {
    return {
      page: 1,
      more: true,
      loading: false,
      videos: []
    }
  },
  methods: {
    openVideo(vid) {
      this.$router.push({
        name: "pa-youtube", //use name for router push
        params: {id: vid}
      });
    },
    load() {
      this.$data.loading = true;

      axios.get('https://roosterapi.patv.in/api/show-videos?show_id=' + this.show.id + '&page=' + this.page).then((res) => {
        var lastId = this.$data.videos[this.$data.videos.length - 1]?.link;
        console.log('focusing', lastId);
        this.$data.videos = [...this.$data.videos, ...res.data.data];
        if (res.data.to === res.data.total) this.more = false;
        this.page++;
        SpatialNavigation.makeFocusable();
        SpatialNavigation.focus('#v-' + lastId);
        // SpatialNavigation.focus(e.target)
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.$data.loading = false;
      });
    }
  },
  mounted() {
    this.load();
  }

}
</script>

<template>
  <div class="row">
    <div class="col-sm-12 mt-10">
      <h2 class="text-4xl font-bold text-red-500 mb-4">{{ show?.name }}</h2>
    </div>

    <div class="col-sm-12">
      <div class="row">
        <div v-for="(v,index) in videos" v-bind:key="index" class="col-sm-2 inline-block">
          <a :id="'v-'+v.link" v-bind:tabindex="index" @click="openVideo(v);$event.preventDefault()"
             @keyup.enter="openVideo(v.link);$event.preventDefault()"
             class="yt-video mb-6 block video rounded-2xl overflow-hidden shadow-lg ">
            <img class="rounded" style="max-width: 100%"
                 v-bind:src="'https://i.ytimg.com/vi/'+v.link+'/hqdefault.jpg'"/>
          </a>
        </div>
        <div class="col-sm-2 inline-block" v-if="more">
          <a v-bind:tabindex="2" @click="load();$event.preventDefault()"
             @keyup.enter="load();$event.preventDefault()"
             class="yt-video mb-6 block py-[5.4rem] video rounded-2xl text-2xl overflow-hidden shadow-lg "
             style="background-color: #fdc9c9;">
            {{ loading ? 'Loading' : 'VIEW MORE' }}
          </a>
        </div>
      </div>
    </div>


  </div>
</template>

<style scoped lang="scss">

</style>
